<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { Rive, Fit, Layout } from '@rive-app/canvas'

const props = defineProps(['card', 'active'])

const canvas = ref(null)

onMounted(() => {
	if (props.card?.rive) {
		const rive = new Rive({
			canvas: canvas.value,
			src: props.card.rive,
			autoplay: true,
			autoBind: true,
			layout: new Layout({
				fit: Fit.Contain,
			}),
			stateMachines: 'crownsStateMachine',
			onLoad: () => {
				let vmi = rive.viewModelInstance
				const booleanProperty = vmi.boolean('active')
				if (props.active) {
					booleanProperty.value = true
				} else {
					booleanProperty.value = false
				}
			},
		})

		watch(
			() => props.active,
			(newValue) => {
				const booleanProperty = rive.viewModelInstance.boolean('active')
				booleanProperty.value = newValue
			},
		)
	}
})
</script>

<template>
	<div :class="['flex w-full flex-col items-center gap-5 text-center transition-all duration-300', { 'opacity-25': !active }]">
		<canvas :class="['max-h-36', { 'max-h-52': props.card?.subtitle == 'The Origin' }]" height="512" width="512" ref="canvas" v-if="card.rive" />
		<img class="max-h-24 max-w-52 object-contain md:max-h-36" :src="card.image" v-else />
		<div>
			<p class="-mb-1 font-medium tracking-normal text-crowns-off-white">{{ card.subtitle }}</p>
			<div class="font-neue-haas-grotesk text-3xl font-semibold">{{ card.title }}</div>
		</div>
		<p class="leading-snug text-crowns-off-white">{{ card.details }}</p>
	</div>
</template>
